import { LuChevronDown, LuChevronUp } from "react-icons/lu";
import { useAccordion } from "./useAccordion";
import "./Accordion.scss";

/**
 * Collapsible labeled section.
 *
 * @param {object} props
 * @param {string} props.label - Header label.
 * @param {boolean} [props.defaultOpen=false] - Whether it starts expanded.
 * @param {import('react').ReactNode} props.children - Body content.
 * @returns {import('react').JSX.Element}
 */
const Accordion = ({ label, defaultOpen = false, children }) => {
    const { isOpen, toggle } = useAccordion(defaultOpen);

    return (
        <div className="site-customization-accordion">
            <button
                type="button"
                className="site-customization-accordion__toggle"
                aria-expanded={isOpen}
                onClick={toggle}
            >
                <span>{label}</span>
                {isOpen ? (
                    <LuChevronUp aria-hidden size={18} />
                ) : (
                    <LuChevronDown aria-hidden size={18} />
                )}
            </button>
            {isOpen ? (
                <div className="site-customization-accordion__body">{children}</div>
            ) : null}
        </div>
    );
};

export default Accordion;
